import { NgModule } from "@angular/core";
import { AnonGuardService } from "app/shared/anon-guard.service";
import { AuthGuardService } from "app/shared/auth-guard.service";
import { canDeactivateGuard } from "app/shared/can-deactivate-guard.service";
import { EntityManagerProviderGuard } from "app/shared/entity-manager-guard";
import { SharedModule } from "app/shared/shared.module";
import { AccountBackordersComponent } from "./account-backorders.component";
import { BackordersComponent } from "./backorders.component";
import { CombinePurchaseOrdersDialogComponent } from "./combine-purchase-orders-dialog.component";
import { CreatePurchaseOrdersComponent } from "./create-purchase-orders.component";
import { EditPoInstructionsDialogComponent } from "./edit-po-instructions-dialog.component";
import { EditPodDialogComponent } from "./edit-pod-dialog.component";
import { ManufBackordersComponent } from "./manuf-backorders.component";
import { PoPrintDialogComponent } from "./po-print-dialog.component";
import { PrintablePoComponent } from "./printable-po.component";
import { PurchaseEOQComponent } from "./purchase-eoq.component";
import { PurchaseOrderApplyChangeDialogComponent } from "./purchase-order-apply-change-dialog.component";
import { PurchaseOrderReceiveComponent } from "./purchase-order-receive.component";
import { PurchaseOrdersComponent } from "./purchase-orders.component";
import { SplitPurchaseOrdersDialogComponent } from "./split-purchase-orders-dialog.component";
import { AddPodsDialogComponent } from "./add-pods-dialog.component";
import { UpdateShipDateDialogComponent } from "./update-ship-date-dialog.component";
import { PurchaseManagerComponent } from "./purchase-manager.component";

export const routes = [
  // Purchase Manager with child routes
  {
    path: "purchasing/manage",
    component: PurchaseManagerComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
    data: { breadcrumb: "Purchasing" },
    children: [
      {
        path: "purchase-orders",
        component: PurchaseOrdersComponent,
        canDeactivate: [canDeactivateGuard],
        data: { breadcrumb: "Purchase Orders" },
      },
      {
        path: "backorders",
        data: { breadcrumb: "Backorders" },
        children: [
          {
            path: "",
            component: BackordersComponent,
            canDeactivate: [canDeactivateGuard],
          },
          {
            path: "account/:guid",
            component: AccountBackordersComponent,
            canDeactivate: [canDeactivateGuard],
            data: { breadcrumb: "Account Backorders" },
          },
          {
            path: "manufacturer/:guid",
            component: ManufBackordersComponent,
            canDeactivate: [canDeactivateGuard],
            data: { breadcrumb: "Manufacturer Backorders" },
          },
        ],
      },
      {
        path: "purchase-eoq",
        component: PurchaseEOQComponent,
        canDeactivate: [canDeactivateGuard],
        data: { breadcrumb: "Purchase EOQ" },
      },
    ],
  },
  {
    path: "create-purchase-orders",
    component: CreatePurchaseOrdersComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
  },
  {
    path: "purchase-order-receive/:poHeaderId",
    component: PurchaseOrderReceiveComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
  },
  {
    path: "printable-po/:poHeaderId",
    component: PrintablePoComponent,
    canActivate: [AuthGuardService, EntityManagerProviderGuard],
  },
  {
    // prefix 'account' here is important - used by anon guard
    path: "account-backorders/:guid",
    component: AccountBackordersComponent,
    canActivate: [AnonGuardService],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: "manufacturer-backorders/:guid",
    component: ManufBackordersComponent,
    canActivate: [AnonGuardService],
    canDeactivate: [canDeactivateGuard],
  },
];
routes.forEach((r: any) => {
  r.data = Object.assign(r.data ?? {}, { icon: "shopping_cart" });
});

@NgModule({
  declarations: [
    PurchaseManagerComponent,
    PurchaseOrdersComponent,
    PurchaseEOQComponent,
    BackordersComponent,
    AccountBackordersComponent,
    ManufBackordersComponent,
    EditPodDialogComponent,
    AddPodsDialogComponent,
    EditPoInstructionsDialogComponent,
    CombinePurchaseOrdersDialogComponent,
    SplitPurchaseOrdersDialogComponent,
    CreatePurchaseOrdersComponent,
    PurchaseOrderReceiveComponent,
    PurchaseOrderApplyChangeDialogComponent,
    PrintablePoComponent,
    PoPrintDialogComponent,
    UpdateShipDateDialogComponent,
  ],
  imports: [SharedModule],
  exports: [],
})
export class PurchasingModule {}
